import { type PaymentMethod } from '../types';
import { NO_PAYMENT_METHOD_NEEDED } from './constants';

/**
 * Stripe SDK doesn't like 0 dollar totals so we don't attempt to confirm payments with that.
 * To be extra safe we are still passing in a payment method id in this scenario.
 */
export const fallbackNoPaymentIsNeeded = (
  paymentMethods: readonly PaymentMethod[],
) => {
  return paymentMethods[0]?.id ?? NO_PAYMENT_METHOD_NEEDED;
};
